import React from 'react';
import { Sparkles } from 'lucide-react';
import EmptyState from '@dashboard/components/EmptyState';
import getPageTypeLabel from '@dashboard/services/getPageTypeLabel';

export default function AIEmptyState({ isNewPage = false, pageType, guidesSlot }) {
  return (
    <div className="flex flex-col gap-6">
      <EmptyState>
        <div className="mb-3 flex size-10 items-center justify-center">
          <Sparkles aria-hidden="true" className="size-5" />
        </div>
        {isNewPage ? (
          <EmptyState.Title>
            Describe the {getPageTypeLabel({ type: pageType })} you want
          </EmptyState.Title>
        ) : (
          <EmptyState.Title>
            Ask about this {getPageTypeLabel({ type: pageType })} or describe a change
          </EmptyState.Title>
        )}
      </EmptyState>
      {guidesSlot}
    </div>
  );
}
